import 'vue-plyr/dist/vue-plyr.css';
import 'slick-carousel/slick/slick.css';
import $ from "jquery";
window.$ = window.jQuery = $;
import 'slick-carousel';
import product from './components/product';
import collapse from './components/collapse';

window.Vue.component('banner-list-featured-products', require('./components/banners/banner-list-featured-products.vue'));
window.Vue.component('banner-list-lites', require('./components/banners/banner-list-lites.vue'));
window.Vue.component('banner-video-home', require('./components/banners/banner-video-home'));
window.Vue.component('bookmark-btn', require('./components/products/bookmark-btn'));
window.Vue.component('custom-list-products', require('./components/products/custom-list-products.vue'));
window.Vue.component('page-product-index', require('./components/pages/product/index'));
window.Vue.component('register-product-view', require('./components/pages/product/register-view'));
window.Vue.component('share-btns', require('./components/share-btns.vue'));
window.Vue.component('list-small-products', require('./components/products/list-small-products'));
window.Vue.component('banner-ways-to-search', require('./components/banners/banner-ways-to-search'));

const rootComponents = new Vue({
    el: '#root-product'
});


$(document).ready(function() {
    product();
    collapse();
});


// WEBPACK FOOTER //
// ./resources/site/js/product.js